<template>
  <div>
    <template>
      <ValidationObserver
        ref="observer"
        v-slot="{ valid }"
      >
        <NavTabs
          customClass="capitalize_title"
          :tabs="tabs"
          :activeTab="newActiveTab"
          @sendData="updateData"
        />

        <SlotScopeWatcher
          :value="valid"
          @change="$emit('validChanged', valid)"
        />
      </ValidationObserver>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';

import Summary from '@/components/forms/sample/SummaryForm.vue';
import Treatmentprogram from './subMenus/TreatmentProgram.vue';
import TechnicalFileCooling from './subMenus/TechnicalFileCooling.vue';
import TechnicalFileClosedLoop from './subMenus/TechnicalFileClosedLoop.vue';

export default {
    components: {
        NavTabs,
        SlotScopeWatcher,
        ValidationObserver,
    },
    props: {
        sample: {
            type: Object,
            default: null,
        },
        mutableValue: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            components: [Summary, this.defineComponentType(), Treatmentprogram],
            tabs: [],
            summaryStep: 3,
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'userLang',
            'units',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    async created() {
        this.$store.dispatch('changeActiveTab', 0);
        // Resest selected mapMutations for ar in the store

        if (!this.units) {
            await this.loadUnits({ siteId: this.mutableValue?.analysisRequest?.site?.id, lang: this.userLang });
        }
        this.tabs = this.tableHeaders();
    },
    methods: {
        ...mapActions({
            loadUnits: 'getUnits',
        }),
        tableHeaders() {
            const payload = { mutableValue: this.mutableValue };
            const headerTitle = ['summary', 'technicalFile', 'treatmentProgram'];
            const headers = this.components.map((component, index) => ({
                index,
                props: payload,
                name: this.$t(`analysisRequests.labels.${headerTitle[index]}`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        defineComponentType() {
            if (this.mutableValue.analysisRequest.component.type.key === 'closed') {
                return TechnicalFileClosedLoop;
            }

            if (this.mutableValue.analysisRequest.component.type.key === 'cooling') {
                return TechnicalFileCooling;
            }
            return null;
        },
        updateData(data) {
            this.$emit('sendData', {
                poNumber: data.poNumber,
            });
        },
    },
};
</script>
